import React from 'react';
import TopBar from './TopBar';
import Navbar from './Navbar';
import Footer from './Footer';
import { Toaster } from './ui/toaster';

const Layout = ({ children }) => (
  <div className="min-h-screen bg-white flex flex-col">
    <TopBar />
    <Navbar />
    <main className="flex-1">{children}</main>
    <Footer />
    <Toaster />
  </div>
);

export default Layout;
